export const getMediaLibDialogMediaFileUrl = (url: string) => {
  const source = url.trim();
  if (/^data:image\//i.test(source) || /^blob:/i.test(source)) return url;
  return `${url}${url.includes("?") ? "&" : "?"}upload=true`;
};
